import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import "@/App.css";
import { LangProvider } from "@/lib/LangContext";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import StickyContactBar from "@/components/StickyContactBar";
import ScrollToTop from "@/components/ScrollToTop";
import useLenis from "@/hooks/useLenis";
import Home from "@/pages/Home";
import AllServices from "@/pages/AllServices";
import AllCities from "@/pages/AllCities";
import ServiceDetail from "@/pages/ServiceDetail";
import CityDetail from "@/pages/CityDetail";
import MiningSector from "@/pages/MiningSector";
import InsightsIndex from "@/pages/InsightsIndex";
import InsightsDetail from "@/pages/InsightsDetail";
import CaseStudiesIndex from "@/pages/CaseStudiesIndex";
import CaseStudyDetail from "@/pages/CaseStudyDetail";
import About from "@/pages/About";
import Contact from "@/pages/Contact";

function Shell() {
  useLenis();
  return (
    <div className="App grain">
      <Nav />
      <ScrollToTop />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<AllServices />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/cities" element={<AllCities />} />
          <Route path="/cities/:slug" element={<CityDetail />} />
          <Route path="/sectors/mining" element={<MiningSector />} />
          <Route path="/insights" element={<InsightsIndex />} />
          <Route path="/insights/:slug" element={<InsightsDetail />} />
          <Route path="/case-studies" element={<CaseStudiesIndex />} />
          <Route path="/case-studies/:slug" element={<CaseStudyDetail />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>
      <Footer />
      <StickyContactBar />
      <Toaster
        theme="dark"
        position="bottom-right"
        offset={80}
        toastOptions={{
          style: {
            background: "hsl(0 0% 8%)",
            border: "1px solid hsl(0 0% 15%)",
            color: "hsl(0 0% 96%)",
            borderRadius: 0,
            fontFamily: "'JetBrains Mono', monospace",
            fontSize: "12px",
            letterSpacing: "0.05em",
          },
        }}
      />
    </div>
  );
}

export default function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <LangProvider>
          <Shell />
        </LangProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}
